<template>
    <NewProgram v-if="openNewProgram" @closeModal="openNewProgram = false" @addProgram="handleAddProgram" />
    <addPhoto v-if="openAddPhoto" @closeModal = "openAddPhoto = false" :university-program-id="university_programId"/>
    <div class="page">
        <div class="world">
            <div class="world__left">
                <p class="customBold">Выберите международную стипендию</p>
                <div class="world__left__block">
                    <div class="world__left__block__in" v-for="(item, index) in stips" :key="item"
                         @click="selectStip(item, index)" :class="{ customStip: selectedStip == index }">
                        <div class="world__left__block__in__top">
                            <img :src="item.image" />
                        </div>
                        <p>{{ item.title }}</p>
                    </div>
                </div>
            </div>
            <div class="world__right">
                <p class="customBold">Выберите степень</p>
                <div class="world__right__block">
                    <div class="world__right__block__in1" v-for="(item, index) in steps" :key="item"
                         @click="selectStep(item, index)" :class="{ customStep: selectedStep == index }" >
                        <div class="world__left__block__in__top">
                            <img :src="item.image" />
                        </div>
                        <p>{{ item.title }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="category">
            <div class="customBold" style="display: flex; justify-content: space-between;">
                <p>Выберите категорию</p>
                <p @click="clearFilters()" style="cursor: pointer;">Очистить фильтр</p>
            </div>
            <div class="category__block">
                <div class="category__block__in" v-for="(item, index) in categories" :key="item"
                     @click="selectCat(item, index)" :class="{ customStip: selectedCat == index }">
                    <div class="category__block__in__top">
                        <img :src="item.icon" />
                    </div>
                    <p style="text-align: center; font-size: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.3472))), 14px) !important;">
                        {{ item.title }}</p>
                </div>
            </div>
        </div>
        <div class="inputs">
            <div class="customInput">
                <label>Выберите подкатегорию</label>
                <customSelect :list="subCategories" v-model="subCatId" @change="updateFilters" />
            </div>
            <div class="customInput">
                <label>Выберите страну</label>
                <customSelect :list="countries" v-model="countryId" @change="updateFilters" />
            </div>
            <div v-for="filter in filters" :key="filter.id" class="customInput">
                <label>{{ filter.value }}</label>
                <customSelect :list="(filter.values || []).map(value => ({ id: value.id, title: `${value.value}` }))"
                              v-model="selectedFilterIds[filter.value]" @change="updateFilters" :isFilter="true" />
            </div>
            <div class="customInput">
                <label>IELTS</label>
                <customSelect :list="ieltsFilter" v-model="filterIeltsValue" @change="updateFilters" />
            </div>
            <div class="customInput">
                <label>Duolingo/Other</label>
                <customSelect :list="duolingo" v-model="duolingoData" @change="updateFilters" />
            </div>
            <div class="range">
              <p>GPA ({{ gpaRange.currentMin }} – {{ gpaRange.currentMax }})</p>
              <rangeUi
                  :min="0" :max="4" :step="0.1"
                  :range="[gpaRange.currentMin, gpaRange.currentMax]"
                  :value="''" name="gpa-range"
                  @updatemin="val => { gpaRange.currentMin = parseFloat(val); updateFilters(); }"
                  @updatemax="val => { gpaRange.currentMax = parseFloat(val); updateFilters(); }"
              />
            </div>
        </div>
        <div class="filter">
            <div class="filter__search bigSearch">
                <input type="search" placeholder="Поиск программ..." style="font-style: italic;" v-model="searchModel"
                       @keyup.enter="updateFilters" class="no-clear-button"/>
                <img src="@/assets/icons/find.svg" @click="searchButton"/>
            </div>
            <div class="filter__images">
                <img src="@/assets/icons/redChange.svg" @click="isFilter = true" />
                <img src="@/assets/icons/redFilter.svg" @click="isSelect = true" />
            </div>
            <div class="filter__select">
                <customSelect :list="sort" v-model="sortBy" @change="updateFilters()" />
            </div>
            <!-- <div class="filter__plus" @click="openNewProgram = true" v-if="$store.state.role == 'curator' || $store.state.role == 'expert' ">
                <img src="@/assets/icons/plus.svg" />
                <p>Добавить программу</p>
            </div> -->
        </div>
        <div class="lineTitle" style="margin: 20px 0;">
            <div class="line"></div>
            <p>Результаты поиска</p>
            <div class="line"></div>
        </div>
        <div class="block" v-if="programsLoading">
            <div class="block__in" v-for="n in 4" :key="'sk-' + n">
                <div class="sk sk--card" />
            </div>
        </div>
        <div class="block" v-else-if="programs.length > 0">
            <div class="block__in" v-for="(item, index) in programs" :key="index">
                <NewCardComponent :item="item" @newFav="newFav"/>
            </div>
        </div>
        <div v-else-if="!programsLoading">
            <p style="font-weight:600; align-items: center; margin: 60px 0; font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px) !important;">Программ не найдено</p>
        </div>
        <div class="paginate">
            <vue-awesome-paginate v-if="totalItems" :total-items="totalItems" :items-per-page="15" v-model="currentPage"
                                  @click="pageChanged" />
        </div>
    </div>
    <teleport to="body">
        <section class="fixed inset-0 bg-black/30 z-[90]" v-if="isSelect" @click="isSelect = false">
            <article @click.stop class="absolute bottom-0 left-0 rounded-t-[24px] bg-white w-full h-3/5 py-[14px] px-4 z-[100] flex flex-col items-center gap-6">
                <span class="bg-black/10 rounded-[8px] w-[46px] h-[8px]"></span>
                <span class="text-[22px] font-bold text-center">
            Сортировка
          </span>
                <ul class="p-0 w-full flex flex-col gap-4">
                    <li
                        v-for="i in sort"
                        class="pb-[16px] border-b border-black/10 flex justify-between"
                    >
                        <div class="flex justify-between items-center w-full cursor-pointer">
                            <span @click="toggle(i.id)" class="text-[16px]">{{ i.title }}</span>

                            <!-- Иконка "выбрано" -->
                            <svg v-if="sortBy === i.id" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 24C13.5759 24 15.1363 23.6896 16.5922 23.0866C18.0481 22.4835 19.371 21.5996 20.4853 20.4853C21.5996 19.371 22.4835 18.0481 23.0866 16.5922C23.6896 15.1363 24 13.5759 24 12C24 10.4241 23.6896 8.86371 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 -2.34822e-08 12 0C8.8174 4.74244e-08 5.76516 1.26428 3.51472 3.51472C1.26428 5.76515 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24ZM11.6907 16.8533L18.3573 8.85333L16.3093 7.14667L10.576 14.0253L7.60933 11.0573L5.724 12.9427L9.724 16.9427L10.756 17.9747L11.6907 16.8533Z"
                                    fill="#FD2D2A"
                                />
                            </svg>
                            <div v-else class="w-[24px] h-[24px] rounded-full bg-black/10" @click="toggle(i.id)"></div>
                        </div>
                    </li>
                </ul>
            </article>
        </section>
        <section class="fixed inset-0 bg-black/30 z-[90]" v-if="isFilter" @click="isFilter = false">
            <article @click.stop class="filterMobile absolute bottom-0 left-0 rounded-t-[24px] bg-white w-full h-3/5 py-[14px] px-4 z-[100] flex flex-col items-center gap-6">
                <span class="bg-black/10 rounded-[8px] w-[46px] h-[8px]"></span>
                <span class="text-[22px] font-bold text-center">
            Фильтр программ
          </span>
                <div class="w-full flex flex-col gap-4">
                    <div class="customInput">
                        <label>Выберите межд. стипендию</label>
                        <customSelect :list="stips" v-model="stipId" @change="stipIdFilter" id="stipId" />
                    </div>
                    <div class="customInput">
                        <label>Выберите степень</label>
                        <customSelect :list="steps" v-model="stepId" @change="updateFilters" />
                    </div>
                    <div class="customInput">
                        <label>Выберите категорию</label>
                        <customSelect :list="categories" v-model="catId" @change="updateFilters" />
                    </div>
                    <div class="customInput">
                        <label>Выберите подкатегорию</label>
                        <customSelect :list="subCategories" v-model="subCatId" @change="updateFilters" />
                    </div>
                    <div class="customInput">
                        <label>Выберите страну</label>
                        <customSelect :list="countries" v-model="countryId" @change="updateFilters" />
                    </div>
                    <div v-for="filter in filters" :key="filter.id" class="customInput">
                        <label>{{ filter.value }}</label>
                        <customSelect :list="(filter.values || []).map(value => ({ id: value.id, title: `${value.value}` }))"
                                      v-model="selectedFilterIds[filter.value]" @change="updateFilters" :isFilter="true" />
                    </div>
                    <div class="range">
                        <p>GPA ({{ gpaRange.currentMin }} – {{ gpaRange.currentMax }})</p>
                        <rangeUi
                            :min="0" :max="4" :step="0.1"
                            :range="[gpaRange.currentMin, gpaRange.currentMax]"
                            :value="''" name="gpa-range-mob"
                            @updatemin="val => { gpaRange.currentMin = parseFloat(val); }"
                            @updatemax="val => { gpaRange.currentMax = parseFloat(val); }"
                        />
                    </div>
                    <div class="customInput">
                        <label>IELTS</label>
                        <customSelect :list="ieltsFilter" v-model="filterIeltsValue" @change="updateFilters" />
                    </div>
                    <div class="customInput">
                        <label>Duolingo/Other</label>
                        <customSelect :list="duolingo" v-model="duolingoData" @change="updateFilters" />
                    </div>
                    <button class="searchButtonMob" @click="updateFilters()">Поиск</button>
                    <button class="clearFilterButton" @click="clearFilters()">Очистить фильтр</button>
                </div>
            </article>
        </section>
    </teleport>
</template>
<script>
import customSelect from "@/components/customSelect.vue";
import { Swiper, SwiperSlide, } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination, EffectCoverflow } from 'swiper';
import "swiper/swiper.min.css";
import NewCardComponent from "@/components/newCardComponent.vue";
import NewProgram from "@/components/newPlatform/newProgram.vue";
import addPhoto from "./newPlatform/addPhoto.vue";
import { toast } from 'vue3-toastify';
SwiperCore.use([Navigation, Pagination, A11y, Autoplay, EffectCoverflow])
import axios from "axios";
import "vue-awesome-paginate/dist/style.css";
import rangeUi from "./rangeUi.vue";
import { mapActions } from "vuex";
export default {
    components: {
        Swiper,
        SwiperSlide,
        NewCardComponent,
        NewProgram,
        customSelect,
        rangeUi,
        addPhoto
    },
    data() {
        return {
            programsForSend: [
                {
                    program_id: null,
                    priority: null,
                }
            ],
            pageCount: '',
            currentPage: 1,
            totalItems: '',
            openAddPhoto: false,
            price_range: {
                currentMin: null,
                currentMax: null,
                min: null,
                max: null
            },
            appFee: {
                currentMin: null,
                currentMax: null,
                min: null,
                max: null
            },
            subCatId: null,
            stipId: null,
            stepId: null,
            sortBy: null,
            catId: null,
            filters: [],
            countryId: null,
            openNewProgram: false,
            university_programId: null,
            selectedStip: -1,
            selectedStep: -1,
            categories: [],
            programs: [],
            programsLoading: false,
            selectedCat: -1,
            subCategories: [],
            gpaRange: {
                min: 0,
                max: 4,
                currentMin: 0,
                currentMax: 4,
            },
            duolingoData: null,
            selectedFilters: {},
            duolingo: [
                {
                    id: 0,
                    title: 'Да'
                },
                {
                    id: 1,
                    title: 'Нет'
                }
            ],
            depositId: null,
            depositList: [
                {
                    id: 1,
                    title: 'Требуется'
                },
                {
                    id: 0,
                    title: 'Не требуется'
                }
            ],
            ieltsFilter: [
                {
                    id: 1,
                    title: '5.0'
                },
                {
                    id: 2,
                    title: '5.5'
                },
                {
                    id: 3,
                    title: '6.0'
                },
                {
                    id: 4,
                    title: '6.5'
                },
                {
                    id: 5,
                    title: '7.0'
                },
                {
                    id: 6,
                    title: '7.5'
                },
                {
                    id: 7,
                    title: '8.0'
                }
            ],
            filterIeltsValue: null,
            sort: [
                {
                    title: 'Выбор',
                    id: 0,
                    type1: '',
                    order_by: 'asc'
                },
                {
                    title: 'Elite',
                    id: 1,
                    type1: 'top',
                    order_by: 'asc'
                },
                {
                    title: 'TOP',
                    id: 2,
                    type1: 'top',
                    order_by: 'desc'
                },
                // {
                //     title: 'Выбор наших менти',
                //     id: 5,
                //     type1: 'is_student_choose',
                //     order_by: 'asc'
                // },
            ],
            selectedFilterIds: {},
            skipPageWatch: false,
            value: [30, 70],
            type: 'Range',
            searchModel: '',
            countries: [],
            steps: [],
            stips: [],
            isSelect: false,
            isFilter: false,
        };
    },
    methods: {
        ...mapActions(["toggleBlock"]),
        newFav() {
            this.updateFilters();
        },
        updateRouteQuery() {
            this.$router.replace({
                query: {
                    page: this.currentPage !== 1 ? this.currentPage : undefined,
                    stip: this.stipId ?? undefined,
                    step: this.stepId ?? undefined,
                    cat: this.catId ?? undefined,
                    subcat: this.subCatId ?? undefined,
                    country: this.countryId ?? undefined,
                    deposit: this.depositId ?? undefined,
                    gpa_from: this.gpaRange.currentMin > 0 ? this.gpaRange.currentMin : undefined,
                    gpa_to: this.gpaRange.currentMax < 4 ? this.gpaRange.currentMax : undefined,
                    ielts: this.filterIeltsValue ?? undefined,
                    duolingo: this.duolingoData ?? undefined,
                    sort: this.sortBy ?? undefined,
                    search: this.searchModel || undefined,
                    price_min: this.price_range.min ?? undefined,
                    price_max: this.price_range.max ?? undefined,
                }
            })
        },
        searchButton(){
            if (this.searchModel !== '') {
                this.updateFilters();
            }
            toast.error('Поле поиска не может быть пустым.');
        },
        stipIdFilter() {
            const val = Number(this.stipId);
            if (this.$store.state.role == 'guest') {
                this.toggleBlock(true);
                return;
            }

            if (val == 4 || val == 5 || val == 7){
                if(val == 4){
                    window.open(
                        "https://www.mastersportal.com/search/master/affordable/germany?de=fulltime&mh=face2face",
                        "_blank"
                    );
                }
                if(val == 5){
                    window.open(
                        "https://stipendiumhungaricum.hu/study-finder/",
                        "_blank"
                    );
                }
                if(val == 7){
                    window.open(
                        "https://shorelight.com/universities/graduate?q=&sort=signature-asc&compareList=&filter=eyJzZW1lc3RlcnMiOltdLCJzZXJ2aWNlcyI6e30sImlzU2Nob2xhcnNoaXBzIjpmYWxzZSwicHJvZ3JhbUxldmVsIjoiIiwidHVpdGlvbnMiOltdLCJzdGFydFNlbWVzdGVyIjoiIiwiYWRtaXNzaW9uc1N1cHBvcnQiOltdLCJyYW5raW5nIjoiIiwicmVnaW9ucyI6W10sImxvY2F0aW9uVHlwZXMiOltdLCJ0b3RhbFN0dWRlbnRFbnJvbGxtZW50cyI6W10sImludGVybmF0aW9uYWxTdHVkZW50UG9wdWxhdGlvbnMiOltdLCJncGEiOltdLCJpZWx0cyI6W10sInRvZWZsIjpbXX0%3D",
                        "_blank"
                    );
                }
            }
            else{
                this.updateFilters();
            }
        },
        handleAddProgram(value){
            this.university_programId = value;
            this.openAddPhoto = true;
        },
        selectStep(item, index) {
            if (this.$store.state.role == 'guest') {
                this.toggleBlock(true);
                return;
            }
            if (this.selectedStep == index) {
                this.selectedStep = -1
                this.stepId = null
            }
            else {
                this.selectedStep = index
                this.stepId = item.id
            }
            this.updateFilters();
        },
        selectStip(item, index) {
            if (this.$store.state.role == 'guest') {
                this.toggleBlock(true);
                return;
            }
            if (this.selectedStip == index) {
                this.selectedStip = -1
                this.stipId = null
            }
            else {
                this.selectedStip = index
                this.stipId = item.id
            }

            if (item.id == 4 || item.id == 5 || item.id == 7){
                if(item.id == 4){
                    window.open(
                        "https://www.mastersportal.com/search/master/affordable/germany?de=fulltime&mh=face2face",
                        "_blank"
                    );
                }
                if(item.id == 5){
                    window.open(
                        "https://stipendiumhungaricum.hu/study-finder/",
                        "_blank"
                    );
                }
                if(item.id == 7){
                    window.open(
                        "https://shorelight.com/universities/graduate?q=&sort=signature-asc&compareList=&filter=eyJzZW1lc3RlcnMiOltdLCJzZXJ2aWNlcyI6e30sImlzU2Nob2xhcnNoaXBzIjpmYWxzZSwicHJvZ3JhbUxldmVsIjoiIiwidHVpdGlvbnMiOltdLCJzdGFydFNlbWVzdGVyIjoiIiwiYWRtaXNzaW9uc1N1cHBvcnQiOltdLCJyYW5raW5nIjoiIiwicmVnaW9ucyI6W10sImxvY2F0aW9uVHlwZXMiOltdLCJ0b3RhbFN0dWRlbnRFbnJvbGxtZW50cyI6W10sImludGVybmF0aW9uYWxTdHVkZW50UG9wdWxhdGlvbnMiOltdLCJncGEiOltdLCJpZWx0cyI6W10sInRvZWZsIjpbXX0%3D",
                        "_blank"
                    );
                }
            }
            else{
                this.updateFilters();
            }
        },
        selectCat(item, index) {
            if (this.$store.state.role == 'guest') {
                this.toggleBlock(true);
                return;
            }
            if (this.selectedCat == index) {
                this.selectedCat = -1
                this.subCategories = []
                this.catId = null
            }
            else {
                this.selectedCat = index
                this.subCategories = item.subCategories
                this.catId = item.id
            }
            this.updateFilters()
        },
        async loadFilters() {
            try {
                // Получение списка типов фильтров
                const filterTypesResponse = await axios.get("/platform/filter-types");
                const filterTypes = filterTypesResponse.data?.data || [];

                const baseFilters = ['Продолжительность обучения'];
                const conditionalFilter = this.stepId == 4 ? 'SAT' : 'GRE/GMAT';
                const filteredFilterTypes = filterTypes.filter(filter =>
                    baseFilters.includes(filter.value) || filter.value === conditionalFilter
                );

                // Загружаем значения для этих фильтров
                const filtersWithValues = await Promise.all(
                    filteredFilterTypes.map(async (filter) => {
                        const valuesResponse = await axios.get(`/platform/filter-values?type=${filter.id}`);
                        return {
                            ...filter,
                            values: valuesResponse.data?.data || [],
                        };
                    })
                );

                // Сохраняем фильтры в компоненте
                this.filters = filtersWithValues.filter(fil => fil.id !== 5);

                // Инициализируем selectedFilters, чтобы не было undefined
                this.selectedFilters = {};
                this.filters.forEach((filter) => {
                    this.selectedFilters[filter.id] = null;
                });

            } catch (error) {
                console.error("Error loading filters:", error);
            }
        },

        async loadDictionaries() {
            const [stipsRes, countriesRes, stepsRes, categoriesRes, priceRes, appFeeRes] = await Promise.all([
                axios.get("/platform/scholarships2"),
                axios.get("/platform/countries"),
                axios.get("/platform/study-degrees"),
                axios.get("/platform/categories"),
                axios.get("/platform/filter-values?type=7"),
                axios.get("/platform/filter-values?type=4")
            ])

            this.stips = stipsRes.data.data
            this.countries = countriesRes.data.data
            this.steps = stepsRes.data.data
            this.categories = categoriesRes.data.data

            this.price_range = {
                min: priceRes.data.min,
                max: priceRes.data.max,
                currentMin: priceRes.data.min,
                currentMax: priceRes.data.max
            }

            this.appFee = {
                min: appFeeRes.data.min,
                max: appFeeRes.data.max,
                currentMin: appFeeRes.data.min,
                currentMax: appFeeRes.data.max
            }
        },
        async loadPrograms() {
            this.programsLoading = true;
            try {
            const newSort = this.sort.find(item => item.id == this.sortBy)?.type1;
            const newSortId = this.sort.find(item => item.id == this.sortBy)?.id;
            const newOrder = this.sort.find(item => item.id == this.sortBy)?.order_by;

            const params = Object.fromEntries(
                Object.entries({
                    page: this.currentPage,
                    scholarship_id: this.stipId,
                    study_degree_id: this.stepId,
                    category_id: this.catId,
                    sub_category_id: this.subCatId,
                    country_id: this.countryId,
                    is_deposit_required: this.depositId,
                    gpa_min_from: this.gpaRange.currentMin > 0 ? this.gpaRange.currentMin : null,
                    gpa_min_to: this.gpaRange.currentMax < 4 ? this.gpaRange.currentMax : null,
                    ielts_min_from: this.filterIeltsValue,
                    duolingo: this.duolingoData,
                    sort: newSort,
                    id: newSortId,
                    order_by: newOrder,
                    search: this.searchModel,
                    price_to: this.price_range.max,
                    price_from: this.price_range.min,
                    ...Object.fromEntries(
                        Object.entries(this.selectedFilterIds || {}).map(([key, value]) => {
                            if (value != null) {
                                const newKey = key === "Продолжительность обучения" ? "duration" : key.toLowerCase();
                                return [`${newKey}_value_id`, value];
                            }
                            return [];
                        }).filter(entry => entry.length > 0)
                    ),

                }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
            )

            const { data } = await axios.get('/V1/universityPrograms', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
                params: params
            });

            this.programs = data.universityPrograms
            this.totalItems = data.pagination.total
            } finally {
                this.programsLoading = false;
            }
        },

        updateFilters() {
            this.currentPage = 1
            this.updateRouteQuery()
        },
        pageChanged(page) {
            this.currentPage = page;
            this.updateRouteQuery()
        },
        clearFilters() {
            this.$router.replace({ query: {} })

            this.currentPage = 1
            this.stipId = null
            this.stepId = null
            this.catId = null
            this.subCatId = null
            this.countryId = null
            this.depositId = null
            this.gpaRange = { min: 0, max: 4, currentMin: 0, currentMax: 4 }
            this.filterIeltsValue = null
            this.duolingoData = null
            this.sortBy = null
            this.searchModel = ''
            this.selectedStip = -1
            this.selectedStep = -1
            this.selectedCat = -1
        },

        close() {
            this.isSelect = false;
        },
        async toggle(id) {
            this.sortBy = id;

            this.close();
            await this.updateFilters();
        },
        syncVisualSelections() {
            this.selectedStip = Array.isArray(this.stips)
                ? this.stips.findIndex(i => i.id === this.stipId)
                : -1

            this.selectedStep = Array.isArray(this.steps)
                ? this.steps.findIndex(i => i.id === this.stepId)
                : -1

            this.selectedCat = Array.isArray(this.categories)
                ? this.categories.findIndex(i => i.id === this.catId)
                : -1

            if (
                this.selectedCat !== -1 &&
                Array.isArray(this.categories) &&
                this.categories[this.selectedCat]
            ) {
                this.subCategories = this.categories[this.selectedCat].subCategories || []
            }
        },
    },
    async created() {
        await this.loadDictionaries()
        await this.loadFilters()
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler(q) {
                this.currentPage = Number(q.page) || 1
                this.stipId = q.stip ? Number(q.stip) : null
                console.log('Stip:', this.stipId)
                this.stepId = q.step ? Number(q.step) : null
                this.catId = q.cat ? Number(q.cat) : null
                this.subCatId = q.subcat ? Number(q.subcat) : null
                this.countryId = q.country ? Number(q.country) : null
                this.depositId = q.deposit ? Number(q.deposit) : null

                this.gpaRange = {
                    min: 0, max: 4,
                    currentMin: q.gpa_from ? parseFloat(q.gpa_from) : 0,
                    currentMax: q.gpa_to   ? parseFloat(q.gpa_to)   : 4,
                }
                this.filterIeltsValue = q.ielts ? Number(q.ielts) : null
                this.duolingoData = q.duolingo ? Number(q.duolingo) : null

                this.sortBy = q.sort ? Number(q.sort) : null
                this.searchModel = q.search || ''

                this.programsLoading = true;

                this.loadDictionaries().then(() => {
                    this.syncVisualSelections()
                    this.loadPrograms()
                })
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.customBold {
    font-weight: 600;
    color: #0000008A;
    font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px) !important;
}

.bigSearch {
    width: 82% !important;
}

.page {
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
}

.line {
    border-top: 1px solid #0000001A;
    width: 100%;
}

.range {
    display: flex;
    flex-direction: column;
    gap: 11px;
    margin-top: -10px;
    width: 100%;
    @media (min-width: 640px) {
        width: 23.5%;
    }
}

.inputs {
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-between;
    gap: 3%;
    row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 1.2))), 32px);
    margin-top: 20px;
    @media(max-width:768px) {
        display: none;
    }
}

.customInput {
    width: 100%;
    @media (min-width: 640px) {
        width: 23.5%;
    }
}

.customStip,
.customStep {
    color: white !important;
    background: #FD2D2A !important;
    font-weight: 600;

    .world__left__block__in__top {
        background-color: white !important;
    }

    .category__block__in__top {
        background-color: white !important;
    }

    .line {
        border-top: 1px solid white !important;
    }
}

.customStep {
    img {
        filter: brightness(0) saturate(100%) invert(32%) sepia(76%) saturate(4782%) hue-rotate(347deg) brightness(105%) contrast(97%) !important;
    }
}

.world {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    &__left {
        width: 60%;

        &__block {
            gap: 2.5%;

            &__in {
                &__top {
                    padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)10px;
                    width: 100%;
                    height: min(max(48px, calc(3rem + ((1vw - 7.68px) * 1.3889))), 64px);
                    border-radius: 10px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }

                    border: 1px solid #0000001A;
                }

                width: 18%;
            }
        }
    }

    &__right {
        width: 32%;
        height: 100%;
        &__block {
            gap: 5%;
            height: 100%;
            &__in1 {
                width: 30%;
            }
        }
    }

    &__left,
    &__right {
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

        &__block {
            display: flex;
            flex-wrap: wrap;
            row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);

            &__in,
            &__in1 {
                cursor: pointer;
                display: flex;
                padding: 8px 8px 10px;
                flex-direction: column;
                align-items: center;
                gap: 10px;
                border-radius: 10px;
                font-weight: 600;
                text-align: center;
            }

            &__in1 {
                background-color: #FFFFFF;

                img {
                    filter: brightness(0) saturate(100%) invert(71%) sepia(1%) saturate(503%) hue-rotate(114deg) brightness(98%) contrast(96%);
                }
            }

            &__in {
                background: white;

                .line {
                    border-top: 1px solid #FD2D2A;
                }
            }
        }
    }

    @media(max-width:768px) {
        display: none;
    }
}

.paginate {
    margin: 0 auto;
}

.category {
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

    &__block {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        gap: 1.257%;
        row-gap: 20px;

        &__in {
            width: 11.4%;
            background-color: white;
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            padding: 8px 8px 10px;
            justify-content: flex-start;
            border-radius: 10px;
            cursor: pointer;
            font-weight: 600;
            p{
                color: #00000054;
            }
            &__top {
                padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)10px;
                width: 100%;
                border-radius: 10px;
                display: flex;
                height: min(max(48px, calc(3rem + ((1vw - 7.68px) * 1.3889))), 64px);
                align-items: center;
                justify-content: center;

                img {
                    width: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                    height: 100%;
                    object-fit: contain;
                }

                border: 1px solid #0000001A;
            }
        }
    }

    @media(max-width:768px) {
        display: none;
    }
}

select {
    border: 1px solid #0000001A;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
}

.filter {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    margin-top: 30px;

    img {
        width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    }

    &__images {
        display: none;
        align-items: center;
        justify-content: center;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        width: 23%;
    }

    input,
    select,
    &__plus {
        width: 100%;
        padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        background-color: transparent;
        border: 1px solid #0000001A;
        box-shadow: 0px 0px 4px 0px #0000000D;
        border-radius: 10px;
        height: 100%;
    }

    &__search {
        width: 60%;
        position: relative;

        img {
            position: absolute;
            transform: translate(-50%, -50%);
            top: 50%;
            right: 10px;
            cursor: pointer;
        }
    }

    &__select {
        width: 15%;

        select {
            padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)5px;
        }
    }

    &__plus {
        width: 23%;
        cursor: pointer;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    @media(max-width:768px) {
        &__search {
            width: 75%;
        }

        &__plus {
            display: none;
        }

        &__select {
            display: none;
        }

        &__images {
            display: flex;
        }
    }
}

.block {
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    row-gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

    &__in {
        width: 49%;
        position: relative;

        &__backdrop {
            position: absolute;
            z-index: 1000;
            inset: 0;
            background-color: rgba(0,0,0, 0.5);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    @media(max-width:768px) {
        row-gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

        &__in {
            width: 100%;
        }
    }
}
</style>